import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Tooltip,
  useMap,
} from "react-leaflet";
import { useEffect } from "react";
import "leaflet/dist/leaflet.css";

const toronto = [43.65107, -79.347015];
const fredericton = [45.9636, -66.6431];
const calgary = [51.0447, -114.0719];
const vancouver = [49.2827, -123.1207];

const newDelhi = [28.6139, 77.209];
const bangalore = [12.9716, 77.5946];

const newYork = [40.7128, -74.006];
const sanFrancisco = [37.7749, -122.4194];

const allLocations = [
  toronto,
  fredericton,
  calgary,
  vancouver,
  newDelhi,
  bangalore,
  newYork,
  sanFrancisco,
];

const customIcon = new L.Icon({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  shadowSize: [41, 41],
});

const FitBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    map.fitBounds(bounds);
  }, [map, bounds]);

  return null;
};

const Map = () => {
  return (
    <div className="location-page p-4 md:p-8 space-y-6">
      <h1 className="text-3xl font-bold text-center op">Our Global Presence</h1>

      <div
        className="rounded-xl shadow-lg overflow-hidden"
        style={{ height: "500px", width: "100%" }}
      >
        <MapContainer
          bounds={allLocations}
          style={{
            height: "100%",
            width: "100%",
            position: "relative",
            zIndex: 1,
          }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {/* Canada */}
          <Marker position={toronto} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              Toronto
            </Tooltip>
            <Popup>
              <strong>🇨🇦 Toronto, Canada</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>
          <Marker position={fredericton} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              Fredericton
            </Tooltip>
            <Popup>
              <strong>🇨🇦 Fredericton, Canada</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>
          <Marker position={calgary} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              Calgary
            </Tooltip>
            <Popup>
              <strong>🇨🇦 Calgary, Canada</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>
          <Marker position={vancouver} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              Vancouver
            </Tooltip>
            <Popup>
              <strong>🇨🇦 Vancouver, Canada</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>

          {/* India */}
          <Marker position={newDelhi} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              New Delhi
            </Tooltip>
            <Popup>
              <strong>🇮🇳 New Delhi, India</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>
          <Marker position={bangalore} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              Bangalore
            </Tooltip>
            <Popup>
              <strong>🇮🇳 Bangalore, India</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>

          {/* USA */}
          <Marker position={newYork} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              New York
            </Tooltip>
            <Popup>
              <strong>🇺🇸 New York, USA</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>
          <Marker position={sanFrancisco} icon={customIcon}>
            <Tooltip direction="top" offset={[0, -20]} permanent>
              San Francisco
            </Tooltip>
            <Popup>
              <strong>🇺🇸 San Francisco, USA</strong>
              <br />
              info@portoconsulting.ca
            </Popup>
          </Marker>

          <FitBounds bounds={allLocations} />
        </MapContainer>
      </div>
    </div>
  );
};

export default Map;
